<div class="full-height">
  <!-- BEGIN APP -->

  <!-- BEGIN SIDEBAR -->
<!--  ToDo Update after implementing auth0 authorization in production-->
  <app-sidebar [menuLinks]="menuItems$ | async"
               *ngIf="!isLoginPage && (auth.isAuthenticated$ | async)"
               [activeRoute]="activeRoute$"
               [menuPinThreeWay]="menuPinThreeWay$ | async"
               [userName]="(user$ | async)?.name"
               [environmentName]="environmentName$ | async"
               (logout)="logoutHandler()"
               (toggleMenuDrawer)="toggleMenuDrawer()"
               (toggleMenu)="toggleMenuPin()"></app-sidebar>
  <!-- END SIDEBAR -->

  <!-- START PAGE-CONTAINER -->
  <page-container>
    <!-- START PAGE HEADER WRAPPER -->
    <auth0-header class="header"
                  [applicationName]="'Requests'"
                  [environmentName]="environmentName$ | async"
                  *ngIf="(isAppView$ | async) === false && !isLoginPage && (auth.isAuthenticated$ | async)"
                  (logout)="logoutHandler()"
                  (toggleMobileSidebar)="toggleMobileSidebar()"
                  [user]="user$ | async">
    </auth0-header>
    <!-- END PAGE HEADER WRAPPER -->

    <!-- START PAGE CONTENT WRAPPER -->
    <div class="page-content-wrapper"
         [ngClass]="{'app-view':isAppView$ | async, 'full-height': (isFullHeightView$ | async)}">

      <!-- START PAGE CONTENT -->
      <div class="content"
           [ngClass]="{'full-height':(isFullHeightView$ | async)}">
        <spinner class="full-height"
                 *ngIf="isLoading$ | async"></spinner>


        <div class="full-height full-width"
             [hidden]="(outletIsVisible$ | async) === false">
          <router-outlet></router-outlet>
        </div>

        <shared-internal-error class="full-height"
                               [errorText]="errorText$ | async"
                               *ngIf="errorIsVisible$ | async"></shared-internal-error>

        <shared-browser-not-supported class="full-height"
                                      *ngIf="browserNowSupported$ | async"></shared-browser-not-supported>

        <access-denied-page *ngIf="(accessDenied$ | async) && !(isDebug$ | async)"></access-denied-page>
      </div>
      <!-- END PAGE CONTENT -->
<!--      ToDo Update after implementing auth0 authorization in production-->
      <footer *ngIf="(isAppView$ | async) == false && !isLoginPage"></footer>
    </div>
    <!-- END PAGE CONTENT WRAPPER -->

  </page-container>
  <!-- END PAGE CONTAINER -->
  <!--START QUICKVIEW -->
  <debug *ngIf="isDebug$ | async"
         [environment]="environment"
         [version]="version$ | async"
         [status]="status$ | async"
         [token]="token$ | async"
         [isStatusLoading]="isStatusLoading$ | async "
         [gitEnvVariables]="gitEnvVariables$ | async"
         (statusExpand)="onApiStatusExpand($event)"
         (copyTokenClick)="onCopyTokenClick($event)">
  </debug>
  <!-- END QUICKVIEW-->
  <!-- END APP -->
</div>
